export enum SubBatchStatus {
  UNSET_SUB_STATUS = 'UNSET_SUB_STATUS', // Do not use, needed because of proto3 limitations
  CREATED = 'CREATED',
  SHIPPED = 'SHIPPED',
  DISTRIBUTED = 'DISTRIBUTED',
  CANCELLED = 'CANCELLED',
  DESTROYED = 'DESTROYED',
}
